export const ADD_CART_ITEM = "ADD_CART_ITEM";
export const UPDATE_CART_ITEMS = "UPDATE_CART_ITEMS";
export const UPDATE_CART_LOADER = "UPDATE_CART_LOADER";
export const UPDATE_VIEW_CART_DATA = "UPDATE_VIEW_CART_DATA";
export const UPDATE_ACI_MODAL = "UPDATE_ACI_MODAL";
export const UPDATE_EDIT_DATA = "UPDATE_EDIT_DATA";
export const UPDATE_SELECTED_ITEM = "UPDATE_SELECTED_ITEM";
